import React from 'react';
import { PractitionerFlowShell } from '../components/practitioners/PractitionerFlowShell';
import { AppStoreButtons } from '../components/AppStoreButtons';
import { welcomeNextSteps } from '../data/practitionerWelcome';

/**
 * /practitioners/welcome — Stripe Checkout success_url.
 *
 * Stripe appends ?session_id={CHECKOUT_SESSION_ID}. This page does NOT treat
 * the redirect as proof of payment; subscription status is confirmed
 * server-side by the Stripe webhook → practitioner_subscriptions.
 *
 * TODO(dev, optional): to show live status, call an authenticated Edge
 * Function (e.g. `get-practitioner-subscription`) that reads
 * practitioner_subscriptions for the signed-in user. Do not read Stripe
 * directly from the browser.
 */
export function PractitionerWelcomePage() {
  return <PractitionerFlowShell currentStep={2} data-id="element-739" data-mp="2b2d6nbhrerwc">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-740" data-mp="2b1lmcwtm4gld">
        {/* Celebration */}
        <section className="rounded-[2rem] bg-purple-800 px-7 py-14 md:px-16 md:py-20 text-center" data-id="element-741" data-mp="2fzn6zm6osnyy">
          <h1 className="font-serif text-4xl md:text-6xl text-white leading-[1.05] tracking-tight" data-id="element-742" data-mp="2rs14ecrhk38z">
            Welcome to <span className="italic" data-id="element-743" data-mp="2nrqyf03p1cu4">Fem Entity.</span>
          </h1>
          <p className="mt-6 text-xl md:text-2xl font-serif text-purple-100" data-id="element-744" data-mp="2iqtjcwdzcywu">Your practitioner account is set up.</p>
          <p className="mt-5 max-w-2xl mx-auto text-base md:text-lg text-purple-100/90 font-light leading-relaxed" data-id="element-745" data-mp="2ds9vurjqnf2d">
            Now download Fem Entity and sign in using the email and password you just created. We'll guide you through
            completing your practitioner profile, services, availability and verification inside the app.
          </p>
          <AppStoreButtons tone="dark" className="mt-10 justify-center items-center" data-id="element-746" data-mp="1v2k2m8vmj1ck" />
        </section>

        {/* What happens next */}
        <section aria-labelledby="next-heading" className="mt-20 md:mt-24 max-w-3xl mx-auto" data-id="element-747" data-mp="1q1w3ezx8re79">
          <h2 id="next-heading" className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700" data-id="element-748" data-mp="1l5fdq1ae8rs2">
            What happens next
          </h2>
          <ol className="mt-8 border-l border-purple-200" data-id="element-749" data-mp="1gfbn4vva89us">
            {welcomeNextSteps.map((step, index) => <li key={step.title} className="relative pl-10 pb-10 last:pb-0" data-id="element-750" data-mp="12glohbste24b" data-mpi={index}>
                <span aria-hidden="true" className="absolute -left-[14px] top-0.5 flex h-7 w-7 items-center justify-center rounded-full bg-purple-700 text-xs font-semibold text-white" data-id="element-751" data-mp="16h5l8e9h73px">
                  {index + 1}
                </span>
                <h3 className="font-serif text-xl md:text-2xl text-charcoal leading-snug" data-id="element-752" data-mp="1leo8fc6i98v9">{step.title}</h3>
                <p className="mt-2 text-base text-charcoal/70 leading-relaxed" data-id="element-753" data-mp="1pg1enndife2p">{step.description}</p>
              </li>)}
          </ol>

          <p className="mt-16 text-center font-serif text-3xl md:text-4xl text-purple-800" data-id="element-754" data-mp="2d4av09ryf9mg">See you inside. 💗</p>
        </section>
      </div>
    </PractitionerFlowShell>;
}